// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__udfHO","content":"RecentSearches_content__1LTMo"};